function __no_antd() {
  console.error('未找到 antd 依赖，无法使用 toast。');
}
var toast = {
  info: __no_antd,
  loading: __no_antd,
  error: __no_antd,
  success: __no_antd,
  warning: __no_antd,
  destroy: __no_antd
};
try {
  var message = require('antd/es/message').default;
  require('antd/es/message/style');
  var lastErrorMessage;
  function info(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    message.info(content, duration, onClose);
  }
  function loading(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    message.loading(content, duration, onClose);
  }
  function error(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    if (message !== lastErrorMessage) {
      lastErrorMessage = message;
    } else {
      message.destroy();
    }
    message.error(content, duration, onClose);
  }
  function success(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    message.success(content, duration, onClose);
  }
  function warning(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    message.warning(content, duration, onClose);
  }
  function destroy() {
    message.destroy();
  }
  toast = {
    info: info,
    loading: loading,
    error: error,
    success: success,
    warning: warning,
    destroy: destroy
  };
} catch (err) {}
export { toast };